// Accessibility helpers.
//
// Much of the UI uses <div>/<li> with onClick for tappable rows and section
// headers. Those are invisible to keyboard and screen-reader users. Spreading
// clickable(fn) onto such an element makes it behave like a button: it becomes
// focusable, announces itself as a button, and activates on Enter/Space.
//
// (Elements that are already <button> don't need this — they get it for free.)

export function clickable(onClick, opts = {}) {
  const props = {
    onClick,
    onKeyDown: (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick(e);
      }
    },
    role: 'button',
    tabIndex: 0,
  };
  if (opts.label) props['aria-label'] = opts.label;
  if (opts.expanded !== undefined) props['aria-expanded'] = opts.expanded;
  return props;
}
